module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ../~/_rc-switch@1.9.0@rc-switch/es/index.js
// module id = 1379
// module chunks = 0